import { FormatType } from "../../utils/types";
import { TypographyProps } from "../Typography/Typography";

export interface DisplayNumberProps
  extends Omit<TypographyProps<"span">, "children"> {
  value: string | number;
  thousandSeparator?: string;
  decimalSeparator?: string;
  trimDecimals?: boolean;
  decimalSpaces?: number;
  format?: FormatType;
  disableTooltip?: boolean;
}

export interface DisplayHoursProps
  extends Omit<TypographyProps<"span">, "children"> {
  value: string | number;
  thousandSeparator?: string;
  decimalSeparator?: string;
  trimZeroMinutes?: boolean;
  trimDecimals?: boolean;
  decimalSpaces?: number;
  format?: FormatType;
  disableTooltip?: boolean;
  withLeadingZero?: boolean;
}
